import React, { FC } from 'react';
import * as Icons from '@mui/icons-material';

export type IconNames = keyof typeof Icons;

export type IconProps = {
  iconName?: IconNames; // iconName is now optional
  iconColor?: string; // add iconColor prop
  props?: Record<string, any>;
};

export const IconComponent: FC<IconProps> = ({ iconName = 'Add', iconColor = 'black', props = {} }) => {
  const Icon = Icons[iconName];

  // Use spread operator for merging props
  const fetchedProps = { ...props };

  return (
    <Icon
      {...fetchedProps}
      style={{ color: iconName === 'Note' ? iconColor : 'black', marginRight: '24px', marginLeft: '5%' }}
    />
  );
};
